var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgViewModuleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 6.66699V24.0003H27.9999V6.66699H5.33325ZM18.6666 9.33366V14.0003H14.6666V9.33366H18.6666ZM7.99992 9.33366H11.9999V14.0003H7.99992V9.33366ZM7.99992 21.3337V16.667H11.9999V21.3337H7.99992ZM14.6666 21.3337V16.667H18.6666V21.3337H14.6666ZM25.3333 21.3337H21.3333V16.667H25.3333V21.3337ZM21.3333 14.0003V9.33366H25.3333V14.0003H21.3333Z",
    fill: "#646464"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgViewModuleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/View_Module_icon.99e8935331079aff38e95cd975808ce0.svg";